import './style.scss'

import React from 'react'
import { VideoID, IComment } from '@types'
// import randomColor from 'randomcolor'

const PUSH = 'PUSH' as const
const READY = 'READY' as const
const PLAYING = 'PLAYING' as const
const OVER = 'OVER' as const
type DanmuStatus = typeof PUSH | 'READY' | 'PLAYING' | 'OVER'


const DEFAULT_DURATION = 7500 // ms
const DEFAULT_FONT_SIZE = 24

interface MessageProps {
  id: string
  content: string,
  status: DanmuStatus
  onUpdateStatus: (id: string, status: DanmuStatus) => void
  // screen: { width: number, height: number }
  speed?: number,
  color?: string
}

class Message extends React.Component<MessageProps> {

  state = {
    y: 30 + Math.random() * 150
  }

  componentDidMount() {
    const delay = 100
    const { id, onUpdateStatus } = this.props

    setTimeout(() => {
      onUpdateStatus(id, PLAYING)
    }, delay)

    setTimeout(() => {
      onUpdateStatus(id, OVER)
    }, delay + this.getDuration())
  }

  getDuration() {
    const { speed = 1 } = this.props
    return DEFAULT_DURATION / speed
  }

  render() {
    const { content, color = '#fff', status } = this.props
    const { y } = this.state
    const fontSize = DEFAULT_FONT_SIZE * (status === 'PUSH' ? 1.5 : 1)

    const style = {
      transitionDuration: this.getDuration() + 'ms',
      top: `${y}px`,
      fontSize,
      color,
    }

    return <div
      className={`danmu-message ${status.toLowerCase()}`}
      style={style}>
      {content}
    </div>
  }
}


interface DanmuProps {
  videoId: VideoID
  frameIdx: number
  comments: IComment[]
}
interface DanmuState {
  danmuQueue: Array<{ id: string, state: DanmuStatus, content: string }>
}

export class Danmu extends React.Component<DanmuProps, DanmuState> {
  state: Readonly<DanmuState> = {
    danmuQueue: []
  }

  componentDidUpdate(prevProps: Readonly<DanmuProps>, prevState: Readonly<DanmuState>, snapshot?: any): void {
    // ignore the update of videos here, can be a problem
    if (prevProps.frameIdx !== this.props.frameIdx) {
      // update queue
      const { comments } = this.props
      const { danmuQueue: queue } = this.state
      const toLoad = comments
        .filter(c => c.frameIdx === this.props.frameIdx && c.videoId === this.props.videoId)
        .filter(c => queue.every(d => d.id !== c.id))
      this.setState({
        danmuQueue: [
          // remove old
          ...queue.filter(c => c.state !== 'OVER'),
          // add new
          ...toLoad.map(({ id, content }) => ({ id, content, state: READY }))
        ]
      })
    }
  }

  push({ id, content }: IComment) {
    const { danmuQueue } = this.state
    this.setState({
      danmuQueue: [...danmuQueue, { id, content, state: PUSH }]
    })
  }

  onUpdateStatus = (id: string, s: DanmuStatus) => {
    const { danmuQueue } = this.state
    const targetDanmu = danmuQueue.find(d => d.id === id)
    if (targetDanmu) {
      targetDanmu.state = s
      this.setState({
        danmuQueue: [...danmuQueue]
      })
    }
  }

  render() {
    const { danmuQueue } = this.state
    return <div className="danmu">
      <div className="danmu-screen">
        {danmuQueue
          .filter(danmu => danmu.state !== 'OVER')
          .map(({ id, state, content }) => <Message
            key={id}
            id={id}
            status={state}
            content={content}
            color={state === 'PUSH' ? '#1E90FF' : '#fff'}
            onUpdateStatus={this.onUpdateStatus}
          />)}
      </div>
    </div>
  }

}
